import { TranslateService } from '@ngx-translate/core';

import { SharedLanguageService } from '@language';
import { UserRights } from '@stylehaven/components';
import { GroupRights } from '../entities/mediahaven-api/groups/create-group.entity';

export const GroupRightCodes: (keyof GroupRights)[] = ['ReadRights', 'WriteRights', 'ExportRights'];
export const UserRightCodes: (keyof UserRights)[] = ['ReadRights', 'WriteRights', 'DeleteRights', 'ExportRights'];

export function getPermissionsTranslation(
    translateService: TranslateService | SharedLanguageService,
    rightCode: string
): string {
    return translateService.instant('modules.general.form.rights.permissions.' + rightCode);
}
